__turbopack_context__.v({
  "instagramContainer": "InstagramEmbed-module-scss-module__2OXzHW__instagramContainer",
});
